import { render, staticRenderFns } from "./SendAlert.vue?vue&type=template&id=6f77a681"
import script from "./SendAlert.vue?vue&type=script&lang=js"
export * from "./SendAlert.vue?vue&type=script&lang=js"
import style0 from "./SendAlert.vue?vue&type=style&index=0&id=6f77a681&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports